import { render, staticRenderFns } from "./FranchiseRegister.vue?vue&type=template&id=685ee42a&"
import script from "./FranchiseRegister.vue?vue&type=script&lang=js&"
export * from "./FranchiseRegister.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseRegister.vue?vue&type=style&index=0&id=685ee42a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports